<template>
  <DialogHeader>
    <div
      class="size-[30px] rounded-full bg-red-200/50 flex items-center justify-center mr-2.5"
    >
      <Icon name="Alert" :size="16" class="stroke-red-700" />
    </div>
    <div>Delete {{ copy.folder }}?</div>
  </DialogHeader>
  <DialogContent>
    <div>
      Are you sure you want to delete
      <span class="font-semibold">{{ copy.folderName }}</span> from your Dacr
      account?
    </div>
  </DialogContent>
  <DialogFooter>
    <UiButton
      class="w-full tablet-h:w-auto mr-2.5 tablet-h:mr-2"
      :disabled="loading"
      @click="close()"
    >
      Cancel
    </UiButton>
    <UiButton
      danger
      class="w-full tablet-h:w-auto"
      :loading="loading"
      @click="handleClick"
    >
      Delete
    </UiButton>
  </DialogFooter>
</template>

<script setup lang="ts">
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import DialogFooter from '@/shared/dialogs/DialogFooter.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import { Dialogs } from '@/shared/dialogs/types'
import { Icon, Table, UiButton } from '@dacr/ui'
import { useDeleteFoldersMutation } from '@/shared/graphql/legacy/generated'
import type { Folder } from '@/shared/graphql/router/graphql'
import { removeItemsFromExplorerCache } from '@/features/explorer/utils/explorerCache'
import { TableTypes } from '@/shared/types/index'

const { close, triggerEvent } = useDialog()
const { open } = useDialog()

const props = defineProps<{
  items: Folder[]
}>()

const table = Table.useTable(TableTypes.Explorer)

const { mutate: deleteFolder, loading } = useDeleteFoldersMutation()

const hasMultipleItems = props.items.length > 1

const copy = {
  folder: hasMultipleItems ? 'folders' : 'folder',
  folderName: hasMultipleItems
    ? `${props.items.length} folders`
    : props.items[0].name,
}

const handleClick = async () => {
  const idsToDelete = props.items.map((item) => item.id)

  try {
    await deleteFolder({
      folderIds: idsToDelete,
    })

    removeItemsFromExplorerCache(idsToDelete)
    table.resetSelection()

    triggerEvent('success')

    close()
  } catch (error) {
    if (error instanceof Error && error.message.includes('inside')) {
      open(Dialogs.CannotDeleteFolder)
    }
  }
}
</script>
